import { render, staticRenderFns } from "./UtilityListDefaultLayout.vue?vue&type=template&id=1245379a"
import script from "./UtilityListDefaultLayout.vue?vue&type=script&lang=js"
export * from "./UtilityListDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports